import { I as Qe } from "./InputAdornment-T4xPPRnD.mjs";
import * as b from "react";
import { _ as g } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { _ as Y } from "./typeof-BVqtjQBM.mjs";
import { _ as Ne, a as Xe } from "./inheritsLoose-OI-DR2K6.mjs";
import { _ as ye } from "./assertThisInitialized-lz6cHcRv.mjs";
import { u as Ye } from "./index-B1qvqCCQ.mjs";
import { j as et } from "./jsx-runtime-3tyXYecC.mjs";
import { c as U, k as me } from "./tss-DN0acMKN.mjs";
const tt = typeof Symbol == "function" && Symbol.for, rt = tt ? Symbol.for("mui.nested") : "__THEME_NESTED__", nt = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
function it(n = {}) {
  const {
    disableGlobal: t = !1,
    productionPrefix: r = "jss",
    seed: e = ""
  } = n, i = e === "" ? "" : `${e}-`;
  let s = 0;
  const a = () => (s += 1, s);
  return (o, l) => {
    const f = l.options.name;
    if (f && f.startsWith("Mui") && !l.options.link && !t) {
      if (nt.includes(o.key))
        return `Mui-${o.key}`;
      const c = `${i}${f}-${o.key}`;
      return !l.options.theme[rt] || e !== "" ? c : `${c}-${a()}`;
    }
    return `${i}${r}${a()}`;
  };
}
function st(n) {
  return n;
}
var be = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
  return typeof n;
} : function(n) {
  return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
}, $ = (typeof window > "u" ? "undefined" : be(window)) === "object" && (typeof document > "u" ? "undefined" : be(document)) === "object" && document.nodeType === 9;
function at(n, t) {
  if (Y(n) != "object" || !n) return n;
  var r = n[Symbol.toPrimitive];
  if (r !== void 0) {
    var e = r.call(n, t);
    if (Y(e) != "object") return e;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
function ot(n) {
  var t = at(n, "string");
  return Y(t) == "symbol" ? t : String(t);
}
function ut(n, t) {
  for (var r = 0; r < t.length; r++) {
    var e = t[r];
    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(n, ot(e.key), e);
  }
}
function Te(n, t, r) {
  return t && ut(n.prototype, t), Object.defineProperty(n, "prototype", {
    writable: !1
  }), n;
}
var lt = {}.constructor;
function ee(n) {
  if (n == null || typeof n != "object") return n;
  if (Array.isArray(n)) return n.map(ee);
  if (n.constructor !== lt) return n;
  var t = {};
  for (var r in n)
    t[r] = ee(n[r]);
  return t;
}
function ce(n, t, r) {
  n === void 0 && (n = "unnamed");
  var e = r.jss, i = ee(t), s = e.plugins.onCreateRule(n, i, r);
  return s || (n[0], null);
}
var Se = function(t, r) {
  for (var e = "", i = 0; i < t.length && t[i] !== "!important"; i++)
    e && (e += r), e += t[i];
  return e;
}, C = function(t) {
  if (!Array.isArray(t)) return t;
  var r = "";
  if (Array.isArray(t[0]))
    for (var e = 0; e < t.length && t[e] !== "!important"; e++)
      r && (r += ", "), r += Se(t[e], " ");
  else r = Se(t, ", ");
  return t[t.length - 1] === "!important" && (r += " !important"), r;
};
function I(n) {
  return n && n.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function O(n, t) {
  for (var r = "", e = 0; e < t; e++)
    r += "  ";
  return r + n;
}
function T(n, t, r) {
  r === void 0 && (r = {});
  var e = "";
  if (!t) return e;
  var i = r, s = i.indent, a = s === void 0 ? 0 : s, o = t.fallbacks;
  r.format === !1 && (a = -1 / 0);
  var l = I(r), f = l.linebreak, c = l.space;
  if (n && a++, o)
    if (Array.isArray(o))
      for (var h = 0; h < o.length; h++) {
        var y = o[h];
        for (var p in y) {
          var v = y[p];
          v != null && (e && (e += f), e += O(p + ":" + c + C(v) + ";", a));
        }
      }
    else
      for (var m in o) {
        var S = o[m];
        S != null && (e && (e += f), e += O(m + ":" + c + C(S) + ";", a));
      }
  for (var K in t) {
    var ge = t[K];
    ge != null && K !== "fallbacks" && (e && (e += f), e += O(K + ":" + c + C(ge) + ";", a));
  }
  return !e && !r.allowEmpty || !n ? e : (a--, e && (e = "" + f + e + f), O("" + n + c + "{" + e, a) + O("}", a));
}
var ft = /([[\].#*$><+~=|^:(),"'`\s])/g, Re = typeof CSS < "u" && CSS.escape, de = function(n) {
  return Re ? Re(n) : n.replace(ft, "\\$1");
}, $e = /* @__PURE__ */ function() {
  function n(r, e, i) {
    this.type = "style", this.isProcessed = !1;
    var s = i.sheet, a = i.Renderer;
    this.key = r, this.options = i, this.style = e, s ? this.renderer = s.renderer : a && (this.renderer = new a());
  }
  var t = n.prototype;
  return t.prop = function(e, i, s) {
    if (i === void 0) return this.style[e];
    var a = s ? s.force : !1;
    if (!a && this.style[e] === i) return this;
    var o = i;
    (!s || s.process !== !1) && (o = this.options.jss.plugins.onChangeValue(i, e, this));
    var l = o == null || o === !1, f = e in this.style;
    if (l && !f && !a) return this;
    var c = l && f;
    if (c ? delete this.style[e] : this.style[e] = o, this.renderable && this.renderer)
      return c ? this.renderer.removeProperty(this.renderable, e) : this.renderer.setProperty(this.renderable, e, o), this;
    var h = this.options.sheet;
    return h && h.attached, this;
  }, n;
}(), te = /* @__PURE__ */ function(n) {
  Ne(t, n);
  function t(e, i, s) {
    var a;
    a = n.call(this, e, i, s) || this;
    var o = s.selector, l = s.scoped, f = s.sheet, c = s.generateId;
    return o ? a.selectorText = o : l !== !1 && (a.id = c(ye(ye(a)), f), a.selectorText = "." + de(a.id)), a;
  }
  var r = t.prototype;
  return r.applyTo = function(i) {
    var s = this.renderer;
    if (s) {
      var a = this.toJSON();
      for (var o in a)
        s.setProperty(i, o, a[o]);
    }
    return this;
  }, r.toJSON = function() {
    var i = {};
    for (var s in this.style) {
      var a = this.style[s];
      typeof a != "object" ? i[s] = a : Array.isArray(a) && (i[s] = C(a));
    }
    return i;
  }, r.toString = function(i) {
    var s = this.options.sheet, a = s ? s.options.link : !1, o = a ? g({}, i, {
      allowEmpty: !0
    }) : i;
    return T(this.selectorText, this.style, o);
  }, Te(t, [{
    key: "selector",
    set: function(i) {
      if (i !== this.selectorText) {
        this.selectorText = i;
        var s = this.renderer, a = this.renderable;
        if (!(!a || !s)) {
          var o = s.setSelector(a, i);
          o || s.replaceRule(a, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), t;
}($e), ct = {
  onCreateRule: function(t, r, e) {
    return t[0] === "@" || e.parent && e.parent.type === "keyframes" ? null : new te(t, r, e);
  }
}, q = {
  indent: 1,
  children: !0
}, dt = /@([\w-]+)/, ht = /* @__PURE__ */ function() {
  function n(r, e, i) {
    this.type = "conditional", this.isProcessed = !1, this.key = r;
    var s = r.match(dt);
    this.at = s ? s[1] : "unknown", this.query = i.name || "@" + this.at, this.options = i, this.rules = new z(g({}, i, {
      parent: this
    }));
    for (var a in e)
      this.rules.add(a, e[a]);
    this.rules.process();
  }
  var t = n.prototype;
  return t.getRule = function(e) {
    return this.rules.get(e);
  }, t.indexOf = function(e) {
    return this.rules.indexOf(e);
  }, t.addRule = function(e, i, s) {
    var a = this.rules.add(e, i, s);
    return a ? (this.options.jss.plugins.onProcessRule(a), a) : null;
  }, t.replaceRule = function(e, i, s) {
    var a = this.rules.replace(e, i, s);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, t.toString = function(e) {
    e === void 0 && (e = q);
    var i = I(e), s = i.linebreak;
    if (e.indent == null && (e.indent = q.indent), e.children == null && (e.children = q.children), e.children === !1)
      return this.query + " {}";
    var a = this.rules.toString(e);
    return a ? this.query + " {" + s + a + s + "}" : "";
  }, n;
}(), vt = /@container|@media|@supports\s+/, pt = {
  onCreateRule: function(t, r, e) {
    return vt.test(t) ? new ht(t, r, e) : null;
  }
}, J = {
  indent: 1,
  children: !0
}, gt = /@keyframes\s+([\w-]+)/, re = /* @__PURE__ */ function() {
  function n(r, e, i) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var s = r.match(gt);
    s && s[1] ? this.name = s[1] : this.name = "noname", this.key = this.type + "-" + this.name, this.options = i;
    var a = i.scoped, o = i.sheet, l = i.generateId;
    this.id = a === !1 ? this.name : de(l(this, o)), this.rules = new z(g({}, i, {
      parent: this
    }));
    for (var f in e)
      this.rules.add(f, e[f], g({}, i, {
        parent: this
      }));
    this.rules.process();
  }
  var t = n.prototype;
  return t.toString = function(e) {
    e === void 0 && (e = J);
    var i = I(e), s = i.linebreak;
    if (e.indent == null && (e.indent = J.indent), e.children == null && (e.children = J.children), e.children === !1)
      return this.at + " " + this.id + " {}";
    var a = this.rules.toString(e);
    return a && (a = "" + s + a + s), this.at + " " + this.id + " {" + a + "}";
  }, n;
}(), yt = /@keyframes\s+/, mt = /\$([\w-]+)/g, ne = function(t, r) {
  return typeof t == "string" ? t.replace(mt, function(e, i) {
    return i in r ? r[i] : e;
  }) : t;
}, xe = function(t, r, e) {
  var i = t[r], s = ne(i, e);
  s !== i && (t[r] = s);
}, bt = {
  onCreateRule: function(t, r, e) {
    return typeof t == "string" && yt.test(t) ? new re(t, r, e) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(t, r, e) {
    return r.type !== "style" || !e || ("animation-name" in t && xe(t, "animation-name", e.keyframes), "animation" in t && xe(t, "animation", e.keyframes)), t;
  },
  onChangeValue: function(t, r, e) {
    var i = e.options.sheet;
    if (!i)
      return t;
    switch (r) {
      case "animation":
        return ne(t, i.keyframes);
      case "animation-name":
        return ne(t, i.keyframes);
      default:
        return t;
    }
  }
}, St = /* @__PURE__ */ function(n) {
  Ne(t, n);
  function t() {
    return n.apply(this, arguments) || this;
  }
  var r = t.prototype;
  return r.toString = function(i) {
    var s = this.options.sheet, a = s ? s.options.link : !1, o = a ? g({}, i, {
      allowEmpty: !0
    }) : i;
    return T(this.key, this.style, o);
  }, t;
}($e), Rt = {
  onCreateRule: function(t, r, e) {
    return e.parent && e.parent.type === "keyframes" ? new St(t, r, e) : null;
  }
}, xt = /* @__PURE__ */ function() {
  function n(r, e, i) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = r, this.style = e, this.options = i;
  }
  var t = n.prototype;
  return t.toString = function(e) {
    var i = I(e), s = i.linebreak;
    if (Array.isArray(this.style)) {
      for (var a = "", o = 0; o < this.style.length; o++)
        a += T(this.at, this.style[o]), this.style[o + 1] && (a += s);
      return a;
    }
    return T(this.at, this.style, e);
  }, n;
}(), Pt = /@font-face/, wt = {
  onCreateRule: function(t, r, e) {
    return Pt.test(t) ? new xt(t, r, e) : null;
  }
}, Ct = /* @__PURE__ */ function() {
  function n(r, e, i) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = r, this.style = e, this.options = i;
  }
  var t = n.prototype;
  return t.toString = function(e) {
    return T(this.key, this.style, e);
  }, n;
}(), kt = {
  onCreateRule: function(t, r, e) {
    return t === "@viewport" || t === "@-ms-viewport" ? new Ct(t, r, e) : null;
  }
}, jt = /* @__PURE__ */ function() {
  function n(r, e, i) {
    this.type = "simple", this.isProcessed = !1, this.key = r, this.value = e, this.options = i;
  }
  var t = n.prototype;
  return t.toString = function(e) {
    if (Array.isArray(this.value)) {
      for (var i = "", s = 0; s < this.value.length; s++)
        i += this.key + " " + this.value[s] + ";", this.value[s + 1] && (i += `
`);
      return i;
    }
    return this.key + " " + this.value + ";";
  }, n;
}(), At = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, It = {
  onCreateRule: function(t, r, e) {
    return t in At ? new jt(t, r, e) : null;
  }
}, Pe = [ct, pt, bt, Rt, wt, kt, It], Ot = {
  process: !0
}, we = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, z = /* @__PURE__ */ function() {
  function n(r) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = r, this.classes = r.classes, this.keyframes = r.keyframes;
  }
  var t = n.prototype;
  return t.add = function(e, i, s) {
    var a = this.options, o = a.parent, l = a.sheet, f = a.jss, c = a.Renderer, h = a.generateId, y = a.scoped, p = g({
      classes: this.classes,
      parent: o,
      sheet: l,
      jss: f,
      Renderer: c,
      generateId: h,
      scoped: y,
      name: e,
      keyframes: this.keyframes,
      selector: void 0
    }, s), v = e;
    e in this.raw && (v = e + "-d" + this.counter++), this.raw[v] = i, v in this.classes && (p.selector = "." + de(this.classes[v]));
    var m = ce(v, i, p);
    if (!m) return null;
    this.register(m);
    var S = p.index === void 0 ? this.index.length : p.index;
    return this.index.splice(S, 0, m), m;
  }, t.replace = function(e, i, s) {
    var a = this.get(e), o = this.index.indexOf(a);
    a && this.remove(a);
    var l = s;
    return o !== -1 && (l = g({}, s, {
      index: o
    })), this.add(e, i, l);
  }, t.get = function(e) {
    return this.map[e];
  }, t.remove = function(e) {
    this.unregister(e), delete this.raw[e.key], this.index.splice(this.index.indexOf(e), 1);
  }, t.indexOf = function(e) {
    return this.index.indexOf(e);
  }, t.process = function() {
    var e = this.options.jss.plugins;
    this.index.slice(0).forEach(e.onProcessRule, e);
  }, t.register = function(e) {
    this.map[e.key] = e, e instanceof te ? (this.map[e.selector] = e, e.id && (this.classes[e.key] = e.id)) : e instanceof re && this.keyframes && (this.keyframes[e.name] = e.id);
  }, t.unregister = function(e) {
    delete this.map[e.key], e instanceof te ? (delete this.map[e.selector], delete this.classes[e.key]) : e instanceof re && delete this.keyframes[e.name];
  }, t.update = function() {
    var e, i, s;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (e = arguments.length <= 0 ? void 0 : arguments[0], i = arguments.length <= 1 ? void 0 : arguments[1], s = arguments.length <= 2 ? void 0 : arguments[2]) : (i = arguments.length <= 0 ? void 0 : arguments[0], s = arguments.length <= 1 ? void 0 : arguments[1], e = null), e)
      this.updateOne(this.get(e), i, s);
    else
      for (var a = 0; a < this.index.length; a++)
        this.updateOne(this.index[a], i, s);
  }, t.updateOne = function(e, i, s) {
    s === void 0 && (s = Ot);
    var a = this.options, o = a.jss.plugins, l = a.sheet;
    if (e.rules instanceof n) {
      e.rules.update(i, s);
      return;
    }
    var f = e.style;
    if (o.onUpdate(i, e, l, s), s.process && f && f !== e.style) {
      o.onProcessStyle(e.style, e, l);
      for (var c in e.style) {
        var h = e.style[c], y = f[c];
        h !== y && e.prop(c, h, we);
      }
      for (var p in f) {
        var v = e.style[p], m = f[p];
        v == null && v !== m && e.prop(p, null, we);
      }
    }
  }, t.toString = function(e) {
    for (var i = "", s = this.options.sheet, a = s ? s.options.link : !1, o = I(e), l = o.linebreak, f = 0; f < this.index.length; f++) {
      var c = this.index[f], h = c.toString(e);
      !h && !a || (i && (i += l), i += h);
    }
    return i;
  }, n;
}(), Ve = /* @__PURE__ */ function() {
  function n(r, e) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = g({}, e, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), e.Renderer && (this.renderer = new e.Renderer(this)), this.rules = new z(this.options);
    for (var i in r)
      this.rules.add(i, r[i]);
    this.rules.process();
  }
  var t = n.prototype;
  return t.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, t.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, t.addRule = function(e, i, s) {
    var a = this.queue;
    this.attached && !a && (this.queue = []);
    var o = this.rules.add(e, i, s);
    return o ? (this.options.jss.plugins.onProcessRule(o), this.attached ? (this.deployed && (a ? a.push(o) : (this.insertRule(o), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), o) : (this.deployed = !1, o)) : null;
  }, t.replaceRule = function(e, i, s) {
    var a = this.rules.get(e);
    if (!a) return this.addRule(e, i, s);
    var o = this.rules.replace(e, i, s);
    return o && this.options.jss.plugins.onProcessRule(o), this.attached ? (this.deployed && this.renderer && (o ? a.renderable && this.renderer.replaceRule(a.renderable, o) : this.renderer.deleteRule(a)), o) : (this.deployed = !1, o);
  }, t.insertRule = function(e) {
    this.renderer && this.renderer.insertRule(e);
  }, t.addRules = function(e, i) {
    var s = [];
    for (var a in e) {
      var o = this.addRule(a, e[a], i);
      o && s.push(o);
    }
    return s;
  }, t.getRule = function(e) {
    return this.rules.get(e);
  }, t.deleteRule = function(e) {
    var i = typeof e == "object" ? e : this.rules.get(e);
    return !i || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !i.renderable ? !1 : (this.rules.remove(i), this.attached && i.renderable && this.renderer ? this.renderer.deleteRule(i.renderable) : !0);
  }, t.indexOf = function(e) {
    return this.rules.indexOf(e);
  }, t.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, t.update = function() {
    var e;
    return (e = this.rules).update.apply(e, arguments), this;
  }, t.updateOne = function(e, i, s) {
    return this.rules.updateOne(e, i, s), this;
  }, t.toString = function(e) {
    return this.rules.toString(e);
  }, n;
}(), Et = /* @__PURE__ */ function() {
  function n() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var t = n.prototype;
  return t.onCreateRule = function(e, i, s) {
    for (var a = 0; a < this.registry.onCreateRule.length; a++) {
      var o = this.registry.onCreateRule[a](e, i, s);
      if (o) return o;
    }
    return null;
  }, t.onProcessRule = function(e) {
    if (!e.isProcessed) {
      for (var i = e.options.sheet, s = 0; s < this.registry.onProcessRule.length; s++)
        this.registry.onProcessRule[s](e, i);
      e.style && this.onProcessStyle(e.style, e, i), e.isProcessed = !0;
    }
  }, t.onProcessStyle = function(e, i, s) {
    for (var a = 0; a < this.registry.onProcessStyle.length; a++)
      i.style = this.registry.onProcessStyle[a](i.style, i, s);
  }, t.onProcessSheet = function(e) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++)
      this.registry.onProcessSheet[i](e);
  }, t.onUpdate = function(e, i, s, a) {
    for (var o = 0; o < this.registry.onUpdate.length; o++)
      this.registry.onUpdate[o](e, i, s, a);
  }, t.onChangeValue = function(e, i, s) {
    for (var a = e, o = 0; o < this.registry.onChangeValue.length; o++)
      a = this.registry.onChangeValue[o](a, i, s);
    return a;
  }, t.use = function(e, i) {
    i === void 0 && (i = {
      queue: "external"
    });
    var s = this.plugins[i.queue];
    s.indexOf(e) === -1 && (s.push(e), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(a, o) {
      for (var l in o)
        l in a && a[l].push(o[l]);
      return a;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, n;
}(), _t = /* @__PURE__ */ function() {
  function n() {
    this.registry = [];
  }
  var t = n.prototype;
  return t.add = function(e) {
    var i = this.registry, s = e.options.index;
    if (i.indexOf(e) === -1) {
      if (i.length === 0 || s >= this.index) {
        i.push(e);
        return;
      }
      for (var a = 0; a < i.length; a++)
        if (i[a].options.index > s) {
          i.splice(a, 0, e);
          return;
        }
    }
  }, t.reset = function() {
    this.registry = [];
  }, t.remove = function(e) {
    var i = this.registry.indexOf(e);
    this.registry.splice(i, 1);
  }, t.toString = function(e) {
    for (var i = e === void 0 ? {} : e, s = i.attached, a = Xe(i, ["attached"]), o = I(a), l = o.linebreak, f = "", c = 0; c < this.registry.length; c++) {
      var h = this.registry[c];
      s != null && h.attached !== s || (f && (f += l), f += h.toString(a));
    }
    return f;
  }, Te(n, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), n;
}(), M = new _t(), ie = typeof globalThis < "u" ? globalThis : typeof window < "u" && window.Math === Math ? window : typeof self < "u" && self.Math === Math ? self : Function("return this")(), se = "2f1acc6c3a606b082e5eef5e54414ffb";
ie[se] == null && (ie[se] = 0);
var Ce = ie[se]++, ke = function(t) {
  t === void 0 && (t = {});
  var r = 0, e = function(s, a) {
    r += 1;
    var o = "", l = "";
    return a && (a.options.classNamePrefix && (l = a.options.classNamePrefix), a.options.jss.id != null && (o = String(a.options.jss.id))), t.minify ? "" + (l || "c") + Ce + o + r : l + s.key + "-" + Ce + (o ? "-" + o : "") + "-" + r;
  };
  return e;
}, Ge = function(t) {
  var r;
  return function() {
    return r || (r = t()), r;
  };
}, Mt = function(t, r) {
  try {
    return t.attributeStyleMap ? t.attributeStyleMap.get(r) : t.style.getPropertyValue(r);
  } catch {
    return "";
  }
}, Nt = function(t, r, e) {
  try {
    var i = e;
    if (Array.isArray(e) && (i = C(e)), t.attributeStyleMap)
      t.attributeStyleMap.set(r, i);
    else {
      var s = i ? i.indexOf("!important") : -1, a = s > -1 ? i.substr(0, s - 1) : i;
      t.style.setProperty(r, a, s > -1 ? "important" : "");
    }
  } catch {
    return !1;
  }
  return !0;
}, Tt = function(t, r) {
  try {
    t.attributeStyleMap ? t.attributeStyleMap.delete(r) : t.style.removeProperty(r);
  } catch {
  }
}, $t = function(t, r) {
  return t.selectorText = r, t.selectorText === r;
}, We = Ge(function() {
  return document.querySelector("head");
});
function Vt(n, t) {
  for (var r = 0; r < n.length; r++) {
    var e = n[r];
    if (e.attached && e.options.index > t.index && e.options.insertionPoint === t.insertionPoint)
      return e;
  }
  return null;
}
function Gt(n, t) {
  for (var r = n.length - 1; r >= 0; r--) {
    var e = n[r];
    if (e.attached && e.options.insertionPoint === t.insertionPoint)
      return e;
  }
  return null;
}
function Wt(n) {
  for (var t = We(), r = 0; r < t.childNodes.length; r++) {
    var e = t.childNodes[r];
    if (e.nodeType === 8 && e.nodeValue.trim() === n)
      return e;
  }
  return null;
}
function zt(n) {
  var t = M.registry;
  if (t.length > 0) {
    var r = Vt(t, n);
    if (r && r.renderer)
      return {
        parent: r.renderer.element.parentNode,
        node: r.renderer.element
      };
    if (r = Gt(t, n), r && r.renderer)
      return {
        parent: r.renderer.element.parentNode,
        node: r.renderer.element.nextSibling
      };
  }
  var e = n.insertionPoint;
  if (e && typeof e == "string") {
    var i = Wt(e);
    if (i)
      return {
        parent: i.parentNode,
        node: i.nextSibling
      };
  }
  return !1;
}
function Kt(n, t) {
  var r = t.insertionPoint, e = zt(t);
  if (e !== !1 && e.parent) {
    e.parent.insertBefore(n, e.node);
    return;
  }
  if (r && typeof r.nodeType == "number") {
    var i = r, s = i.parentNode;
    s && s.insertBefore(n, i.nextSibling);
    return;
  }
  We().appendChild(n);
}
var Ut = Ge(function() {
  var n = document.querySelector('meta[property="csp-nonce"]');
  return n ? n.getAttribute("content") : null;
}), je = function(t, r, e) {
  try {
    "insertRule" in t ? t.insertRule(r, e) : "appendRule" in t && t.appendRule(r);
  } catch {
    return !1;
  }
  return t.cssRules[e];
}, Ae = function(t, r) {
  var e = t.cssRules.length;
  return r === void 0 || r > e ? e : r;
}, qt = function() {
  var t = document.createElement("style");
  return t.textContent = `
`, t;
}, Jt = /* @__PURE__ */ function() {
  function n(r) {
    this.getPropertyValue = Mt, this.setProperty = Nt, this.removeProperty = Tt, this.setSelector = $t, this.hasInsertedRules = !1, this.cssRules = [], r && M.add(r), this.sheet = r;
    var e = this.sheet ? this.sheet.options : {}, i = e.media, s = e.meta, a = e.element;
    this.element = a || qt(), this.element.setAttribute("data-jss", ""), i && this.element.setAttribute("media", i), s && this.element.setAttribute("data-meta", s);
    var o = Ut();
    o && this.element.setAttribute("nonce", o);
  }
  var t = n.prototype;
  return t.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      Kt(this.element, this.sheet.options);
      var e = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && e && (this.hasInsertedRules = !1, this.deploy());
    }
  }, t.detach = function() {
    if (this.sheet) {
      var e = this.element.parentNode;
      e && e.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, t.deploy = function() {
    var e = this.sheet;
    if (e) {
      if (e.options.link) {
        this.insertRules(e.rules);
        return;
      }
      this.element.textContent = `
` + e.toString() + `
`;
    }
  }, t.insertRules = function(e, i) {
    for (var s = 0; s < e.index.length; s++)
      this.insertRule(e.index[s], s, i);
  }, t.insertRule = function(e, i, s) {
    if (s === void 0 && (s = this.element.sheet), e.rules) {
      var a = e, o = s;
      if (e.type === "conditional" || e.type === "keyframes") {
        var l = Ae(s, i);
        if (o = je(s, a.toString({
          children: !1
        }), l), o === !1)
          return !1;
        this.refCssRule(e, l, o);
      }
      return this.insertRules(a.rules, o), o;
    }
    var f = e.toString();
    if (!f) return !1;
    var c = Ae(s, i), h = je(s, f, c);
    return h === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(e, c, h), h);
  }, t.refCssRule = function(e, i, s) {
    e.renderable = s, e.options.parent instanceof Ve && this.cssRules.splice(i, 0, s);
  }, t.deleteRule = function(e) {
    var i = this.element.sheet, s = this.indexOf(e);
    return s === -1 ? !1 : (i.deleteRule(s), this.cssRules.splice(s, 1), !0);
  }, t.indexOf = function(e) {
    return this.cssRules.indexOf(e);
  }, t.replaceRule = function(e, i) {
    var s = this.indexOf(e);
    return s === -1 ? !1 : (this.element.sheet.deleteRule(s), this.cssRules.splice(s, 1), this.insertRule(i, s));
  }, t.getRules = function() {
    return this.element.sheet.cssRules;
  }, n;
}(), Lt = 0, Dt = /* @__PURE__ */ function() {
  function n(r) {
    this.id = Lt++, this.version = "10.10.0", this.plugins = new Et(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: ke,
      Renderer: $ ? Jt : null,
      plugins: []
    }, this.generateId = ke({
      minify: !1
    });
    for (var e = 0; e < Pe.length; e++)
      this.plugins.use(Pe[e], {
        queue: "internal"
      });
    this.setup(r);
  }
  var t = n.prototype;
  return t.setup = function(e) {
    return e === void 0 && (e = {}), e.createGenerateId && (this.options.createGenerateId = e.createGenerateId), e.id && (this.options.id = g({}, this.options.id, e.id)), (e.createGenerateId || e.id) && (this.generateId = this.options.createGenerateId(this.options.id)), e.insertionPoint != null && (this.options.insertionPoint = e.insertionPoint), "Renderer" in e && (this.options.Renderer = e.Renderer), e.plugins && this.use.apply(this, e.plugins), this;
  }, t.createStyleSheet = function(e, i) {
    i === void 0 && (i = {});
    var s = i, a = s.index;
    typeof a != "number" && (a = M.index === 0 ? 0 : M.index + 1);
    var o = new Ve(e, g({}, i, {
      jss: this,
      generateId: i.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: a
    }));
    return this.plugins.onProcessSheet(o), o;
  }, t.removeStyleSheet = function(e) {
    return e.detach(), M.remove(e), this;
  }, t.createRule = function(e, i, s) {
    if (i === void 0 && (i = {}), s === void 0 && (s = {}), typeof e == "object")
      return this.createRule(void 0, e, i);
    var a = g({}, s, {
      name: e,
      jss: this,
      Renderer: this.options.Renderer
    });
    a.generateId || (a.generateId = this.generateId), a.classes || (a.classes = {}), a.keyframes || (a.keyframes = {});
    var o = ce(e, i, a);
    return o && this.plugins.onProcessRule(o), o;
  }, t.use = function() {
    for (var e = this, i = arguments.length, s = new Array(i), a = 0; a < i; a++)
      s[a] = arguments[a];
    return s.forEach(function(o) {
      e.plugins.use(o);
    }), this;
  }, n;
}(), he = function(t) {
  return new Dt(t);
}, ve = typeof CSS == "object" && CSS != null && "number" in CSS;
function ze(n) {
  var t = null;
  for (var r in n) {
    var e = n[r], i = typeof e;
    if (i === "function")
      t || (t = {}), t[r] = e;
    else if (i === "object" && e !== null && !Array.isArray(e)) {
      var s = ze(e);
      s && (t || (t = {}), t[r] = s);
    }
  }
  return t;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
he();
var Ke = Date.now(), L = "fnValues" + Ke, D = "fnStyle" + ++Ke, Ft = function() {
  return {
    onCreateRule: function(r, e, i) {
      if (typeof e != "function") return null;
      var s = ce(r, {}, i);
      return s[D] = e, s;
    },
    onProcessStyle: function(r, e) {
      if (L in e || D in e) return r;
      var i = {};
      for (var s in r) {
        var a = r[s];
        typeof a == "function" && (delete r[s], i[s] = a);
      }
      return e[L] = i, r;
    },
    onUpdate: function(r, e, i, s) {
      var a = e, o = a[D];
      o && (a.style = o(r) || {});
      var l = a[L];
      if (l)
        for (var f in l)
          a.prop(f, l[f](r), s);
    }
  };
}, x = "@global", ae = "@global ", Ht = /* @__PURE__ */ function() {
  function n(r, e, i) {
    this.type = "global", this.at = x, this.isProcessed = !1, this.key = r, this.options = i, this.rules = new z(g({}, i, {
      parent: this
    }));
    for (var s in e)
      this.rules.add(s, e[s]);
    this.rules.process();
  }
  var t = n.prototype;
  return t.getRule = function(e) {
    return this.rules.get(e);
  }, t.addRule = function(e, i, s) {
    var a = this.rules.add(e, i, s);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, t.replaceRule = function(e, i, s) {
    var a = this.rules.replace(e, i, s);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, t.indexOf = function(e) {
    return this.rules.indexOf(e);
  }, t.toString = function(e) {
    return this.rules.toString(e);
  }, n;
}(), Bt = /* @__PURE__ */ function() {
  function n(r, e, i) {
    this.type = "global", this.at = x, this.isProcessed = !1, this.key = r, this.options = i;
    var s = r.substr(ae.length);
    this.rule = i.jss.createRule(s, e, g({}, i, {
      parent: this
    }));
  }
  var t = n.prototype;
  return t.toString = function(e) {
    return this.rule ? this.rule.toString(e) : "";
  }, n;
}(), Zt = /\s*,\s*/g;
function Ue(n, t) {
  for (var r = n.split(Zt), e = "", i = 0; i < r.length; i++)
    e += t + " " + r[i].trim(), r[i + 1] && (e += ", ");
  return e;
}
function Qt(n, t) {
  var r = n.options, e = n.style, i = e ? e[x] : null;
  if (i) {
    for (var s in i)
      t.addRule(s, i[s], g({}, r, {
        selector: Ue(s, n.selector)
      }));
    delete e[x];
  }
}
function Xt(n, t) {
  var r = n.options, e = n.style;
  for (var i in e)
    if (!(i[0] !== "@" || i.substr(0, x.length) !== x)) {
      var s = Ue(i.substr(x.length), n.selector);
      t.addRule(s, e[i], g({}, r, {
        selector: s
      })), delete e[i];
    }
}
function Yt() {
  function n(r, e, i) {
    if (!r) return null;
    if (r === x)
      return new Ht(r, e, i);
    if (r[0] === "@" && r.substr(0, ae.length) === ae)
      return new Bt(r, e, i);
    var s = i.parent;
    return s && (s.type === "global" || s.options.parent && s.options.parent.type === "global") && (i.scoped = !1), !i.selector && i.scoped === !1 && (i.selector = r), null;
  }
  function t(r, e) {
    r.type !== "style" || !e || (Qt(r, e), Xt(r, e));
  }
  return {
    onCreateRule: n,
    onProcessRule: t
  };
}
var Ie = /\s*,\s*/g, er = /&/g, tr = /\$([\w-]+)/g;
function rr() {
  function n(i, s) {
    return function(a, o) {
      var l = i.getRule(o) || s && s.getRule(o);
      return l ? l.selector : o;
    };
  }
  function t(i, s) {
    for (var a = s.split(Ie), o = i.split(Ie), l = "", f = 0; f < a.length; f++)
      for (var c = a[f], h = 0; h < o.length; h++) {
        var y = o[h];
        l && (l += ", "), l += y.indexOf("&") !== -1 ? y.replace(er, c) : c + " " + y;
      }
    return l;
  }
  function r(i, s, a) {
    if (a) return g({}, a, {
      index: a.index + 1
    });
    var o = i.options.nestingLevel;
    o = o === void 0 ? 1 : o + 1;
    var l = g({}, i.options, {
      nestingLevel: o,
      index: s.indexOf(i) + 1
      // We don't need the parent name to be set options for chlid.
    });
    return delete l.name, l;
  }
  function e(i, s, a) {
    if (s.type !== "style") return i;
    var o = s, l = o.options.parent, f, c;
    for (var h in i) {
      var y = h.indexOf("&") !== -1, p = h[0] === "@";
      if (!(!y && !p)) {
        if (f = r(o, l, f), y) {
          var v = t(h, o.selector);
          c || (c = n(l, a)), v = v.replace(tr, c);
          var m = o.key + "-" + h;
          "replaceRule" in l ? l.replaceRule(m, i[h], g({}, f, {
            selector: v
          })) : l.addRule(m, i[h], g({}, f, {
            selector: v
          }));
        } else p && l.addRule(h, {}, f).addRule(o.key, i[h], {
          selector: o.selector
        });
        delete i[h];
      }
    }
    return i;
  }
  return {
    onProcessStyle: e
  };
}
var nr = /[A-Z]/g, ir = /^ms-/, F = {};
function sr(n) {
  return "-" + n.toLowerCase();
}
function qe(n) {
  if (F.hasOwnProperty(n))
    return F[n];
  var t = n.replace(nr, sr);
  return F[n] = ir.test(t) ? "-" + t : t;
}
function W(n) {
  var t = {};
  for (var r in n) {
    var e = r.indexOf("--") === 0 ? r : qe(r);
    t[e] = n[r];
  }
  return n.fallbacks && (Array.isArray(n.fallbacks) ? t.fallbacks = n.fallbacks.map(W) : t.fallbacks = W(n.fallbacks)), t;
}
function ar() {
  function n(r) {
    if (Array.isArray(r)) {
      for (var e = 0; e < r.length; e++)
        r[e] = W(r[e]);
      return r;
    }
    return W(r);
  }
  function t(r, e, i) {
    if (e.indexOf("--") === 0)
      return r;
    var s = qe(e);
    return e === s ? r : (i.prop(s, r), null);
  }
  return {
    onProcessStyle: n,
    onChangeValue: t
  };
}
var u = ve && CSS ? CSS.px : "px", V = ve && CSS ? CSS.ms : "ms", k = ve && CSS ? CSS.percent : "%", or = {
  // Animation properties
  "animation-delay": V,
  "animation-duration": V,
  // Background properties
  "background-position": u,
  "background-position-x": u,
  "background-position-y": u,
  "background-size": u,
  // Border Properties
  border: u,
  "border-bottom": u,
  "border-bottom-left-radius": u,
  "border-bottom-right-radius": u,
  "border-bottom-width": u,
  "border-left": u,
  "border-left-width": u,
  "border-radius": u,
  "border-right": u,
  "border-right-width": u,
  "border-top": u,
  "border-top-left-radius": u,
  "border-top-right-radius": u,
  "border-top-width": u,
  "border-width": u,
  "border-block": u,
  "border-block-end": u,
  "border-block-end-width": u,
  "border-block-start": u,
  "border-block-start-width": u,
  "border-block-width": u,
  "border-inline": u,
  "border-inline-end": u,
  "border-inline-end-width": u,
  "border-inline-start": u,
  "border-inline-start-width": u,
  "border-inline-width": u,
  "border-start-start-radius": u,
  "border-start-end-radius": u,
  "border-end-start-radius": u,
  "border-end-end-radius": u,
  // Margin properties
  margin: u,
  "margin-bottom": u,
  "margin-left": u,
  "margin-right": u,
  "margin-top": u,
  "margin-block": u,
  "margin-block-end": u,
  "margin-block-start": u,
  "margin-inline": u,
  "margin-inline-end": u,
  "margin-inline-start": u,
  // Padding properties
  padding: u,
  "padding-bottom": u,
  "padding-left": u,
  "padding-right": u,
  "padding-top": u,
  "padding-block": u,
  "padding-block-end": u,
  "padding-block-start": u,
  "padding-inline": u,
  "padding-inline-end": u,
  "padding-inline-start": u,
  // Mask properties
  "mask-position-x": u,
  "mask-position-y": u,
  "mask-size": u,
  // Width and height properties
  height: u,
  width: u,
  "min-height": u,
  "max-height": u,
  "min-width": u,
  "max-width": u,
  // Position properties
  bottom: u,
  left: u,
  top: u,
  right: u,
  inset: u,
  "inset-block": u,
  "inset-block-end": u,
  "inset-block-start": u,
  "inset-inline": u,
  "inset-inline-end": u,
  "inset-inline-start": u,
  // Shadow properties
  "box-shadow": u,
  "text-shadow": u,
  // Column properties
  "column-gap": u,
  "column-rule": u,
  "column-rule-width": u,
  "column-width": u,
  // Font and text properties
  "font-size": u,
  "font-size-delta": u,
  "letter-spacing": u,
  "text-decoration-thickness": u,
  "text-indent": u,
  "text-stroke": u,
  "text-stroke-width": u,
  "word-spacing": u,
  // Motion properties
  motion: u,
  "motion-offset": u,
  // Outline properties
  outline: u,
  "outline-offset": u,
  "outline-width": u,
  // Perspective properties
  perspective: u,
  "perspective-origin-x": k,
  "perspective-origin-y": k,
  // Transform properties
  "transform-origin": k,
  "transform-origin-x": k,
  "transform-origin-y": k,
  "transform-origin-z": k,
  // Transition properties
  "transition-delay": V,
  "transition-duration": V,
  // Alignment properties
  "vertical-align": u,
  "flex-basis": u,
  // Some random properties
  "shape-margin": u,
  size: u,
  gap: u,
  // Grid properties
  grid: u,
  "grid-gap": u,
  "row-gap": u,
  "grid-row-gap": u,
  "grid-column-gap": u,
  "grid-template-rows": u,
  "grid-template-columns": u,
  "grid-auto-rows": u,
  "grid-auto-columns": u,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  "box-shadow-x": u,
  "box-shadow-y": u,
  "box-shadow-blur": u,
  "box-shadow-spread": u,
  "font-line-height": u,
  "text-shadow-x": u,
  "text-shadow-y": u,
  "text-shadow-blur": u
};
function Je(n) {
  var t = /(-[a-z])/g, r = function(a) {
    return a[1].toUpperCase();
  }, e = {};
  for (var i in n)
    e[i] = n[i], e[i.replace(t, r)] = n[i];
  return e;
}
var ur = Je(or);
function N(n, t, r) {
  if (t == null) return t;
  if (Array.isArray(t))
    for (var e = 0; e < t.length; e++)
      t[e] = N(n, t[e], r);
  else if (typeof t == "object")
    if (n === "fallbacks")
      for (var i in t)
        t[i] = N(i, t[i], r);
    else
      for (var s in t)
        t[s] = N(n + "-" + s, t[s], r);
  else if (typeof t == "number" && isNaN(t) === !1) {
    var a = r[n] || ur[n];
    return a && !(t === 0 && a === u) ? typeof a == "function" ? a(t).toString() : "" + t + a : t.toString();
  }
  return t;
}
function lr(n) {
  n === void 0 && (n = {});
  var t = Je(n);
  function r(i, s) {
    if (s.type !== "style") return i;
    for (var a in i)
      i[a] = N(a, i[a], t);
    return i;
  }
  function e(i, s) {
    return N(s, i, t);
  }
  return {
    onProcessStyle: r,
    onChangeValue: e
  };
}
function oe(n, t) {
  (t == null || t > n.length) && (t = n.length);
  for (var r = 0, e = new Array(t); r < t; r++) e[r] = n[r];
  return e;
}
function fr(n) {
  if (Array.isArray(n)) return oe(n);
}
function cr(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function dr(n, t) {
  if (n) {
    if (typeof n == "string") return oe(n, t);
    var r = Object.prototype.toString.call(n).slice(8, -1);
    if (r === "Object" && n.constructor && (r = n.constructor.name), r === "Map" || r === "Set") return Array.from(n);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return oe(n, t);
  }
}
function hr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vr(n) {
  return fr(n) || cr(n) || dr(n) || hr();
}
var E = "", ue = "", Le = "", De = "", pr = $ && "ontouchstart" in document.documentElement;
if ($) {
  var H = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  }, gr = document.createElement("p"), B = gr.style, yr = "Transform";
  for (var Z in H)
    if (Z + yr in B) {
      E = Z, ue = H[Z];
      break;
    }
  E === "Webkit" && "msHyphens" in B && (E = "ms", ue = H.ms, De = "edge"), E === "Webkit" && "-apple-trailing-word" in B && (Le = "apple");
}
var d = {
  js: E,
  css: ue,
  vendor: Le,
  browser: De,
  isTouch: pr
};
function mr(n) {
  return n[1] === "-" || d.js === "ms" ? n : "@" + d.css + "keyframes" + n.substr(10);
}
var br = {
  noPrefill: ["appearance"],
  supportedProperty: function(t) {
    return t !== "appearance" ? !1 : d.js === "ms" ? "-webkit-" + t : d.css + t;
  }
}, Sr = {
  noPrefill: ["color-adjust"],
  supportedProperty: function(t) {
    return t !== "color-adjust" ? !1 : d.js === "Webkit" ? d.css + "print-" + t : t;
  }
}, Rr = /[-\s]+(.)?/g;
function xr(n, t) {
  return t ? t.toUpperCase() : "";
}
function pe(n) {
  return n.replace(Rr, xr);
}
function P(n) {
  return pe("-" + n);
}
var Pr = {
  noPrefill: ["mask"],
  supportedProperty: function(t, r) {
    if (!/^mask/.test(t)) return !1;
    if (d.js === "Webkit") {
      var e = "mask-image";
      if (pe(e) in r)
        return t;
      if (d.js + P(e) in r)
        return d.css + t;
    }
    return t;
  }
}, wr = {
  noPrefill: ["text-orientation"],
  supportedProperty: function(t) {
    return t !== "text-orientation" ? !1 : d.vendor === "apple" && !d.isTouch ? d.css + t : t;
  }
}, Cr = {
  noPrefill: ["transform"],
  supportedProperty: function(t, r, e) {
    return t !== "transform" ? !1 : e.transform ? t : d.css + t;
  }
}, kr = {
  noPrefill: ["transition"],
  supportedProperty: function(t, r, e) {
    return t !== "transition" ? !1 : e.transition ? t : d.css + t;
  }
}, jr = {
  noPrefill: ["writing-mode"],
  supportedProperty: function(t) {
    return t !== "writing-mode" ? !1 : d.js === "Webkit" || d.js === "ms" && d.browser !== "edge" ? d.css + t : t;
  }
}, Ar = {
  noPrefill: ["user-select"],
  supportedProperty: function(t) {
    return t !== "user-select" ? !1 : d.js === "Moz" || d.js === "ms" || d.vendor === "apple" ? d.css + t : t;
  }
}, Ir = {
  supportedProperty: function(t, r) {
    if (!/^break-/.test(t)) return !1;
    if (d.js === "Webkit") {
      var e = "WebkitColumn" + P(t);
      return e in r ? d.css + "column-" + t : !1;
    }
    if (d.js === "Moz") {
      var i = "page" + P(t);
      return i in r ? "page-" + t : !1;
    }
    return !1;
  }
}, Or = {
  supportedProperty: function(t, r) {
    if (!/^(border|margin|padding)-inline/.test(t)) return !1;
    if (d.js === "Moz") return t;
    var e = t.replace("-inline", "");
    return d.js + P(e) in r ? d.css + e : !1;
  }
}, Er = {
  supportedProperty: function(t, r) {
    return pe(t) in r ? t : !1;
  }
}, _r = {
  supportedProperty: function(t, r) {
    var e = P(t);
    return t[0] === "-" || t[0] === "-" && t[1] === "-" ? t : d.js + e in r ? d.css + t : d.js !== "Webkit" && "Webkit" + e in r ? "-webkit-" + t : !1;
  }
}, Mr = {
  supportedProperty: function(t) {
    return t.substring(0, 11) !== "scroll-snap" ? !1 : d.js === "ms" ? "" + d.css + t : t;
  }
}, Nr = {
  supportedProperty: function(t) {
    return t !== "overscroll-behavior" ? !1 : d.js === "ms" ? d.css + "scroll-chaining" : t;
  }
}, Tr = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
  // 'align-self' is handled by 'align-self' plugin.
}, $r = {
  supportedProperty: function(t, r) {
    var e = Tr[t];
    return e && d.js + P(e) in r ? d.css + e : !1;
  }
}, Fe = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
}, Vr = Object.keys(Fe), Gr = function(t) {
  return d.css + t;
}, Wr = {
  supportedProperty: function(t, r, e) {
    var i = e.multiple;
    if (Vr.indexOf(t) > -1) {
      var s = Fe[t];
      if (!Array.isArray(s))
        return d.js + P(s) in r ? d.css + s : !1;
      if (!i) return !1;
      for (var a = 0; a < s.length; a++)
        if (!(d.js + P(s[0]) in r))
          return !1;
      return s.map(Gr);
    }
    return !1;
  }
}, He = [br, Sr, Pr, wr, Cr, kr, jr, Ar, Ir, Or, Er, _r, Mr, Nr, $r, Wr], Oe = He.filter(function(n) {
  return n.supportedProperty;
}).map(function(n) {
  return n.supportedProperty;
}), zr = He.filter(function(n) {
  return n.noPrefill;
}).reduce(function(n, t) {
  return n.push.apply(n, vr(t.noPrefill)), n;
}, []), _, w = {};
if ($) {
  _ = document.createElement("p");
  var Q = window.getComputedStyle(document.documentElement, "");
  for (var X in Q)
    isNaN(X) || (w[Q[X]] = Q[X]);
  zr.forEach(function(n) {
    return delete w[n];
  });
}
function le(n, t) {
  if (t === void 0 && (t = {}), !_) return n;
  if (w[n] != null)
    return w[n];
  (n === "transition" || n === "transform") && (t[n] = n in _.style);
  for (var r = 0; r < Oe.length && (w[n] = Oe[r](n, _.style, t), !w[n]); r++)
    ;
  try {
    _.style[n] = "";
  } catch {
    return !1;
  }
  return w[n];
}
var j = {}, Kr = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
}, Ur = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g, R;
function qr(n, t, r) {
  if (t === "var") return "var";
  if (t === "all") return "all";
  if (r === "all") return ", all";
  var e = t ? le(t) : ", " + le(r);
  return e || t || r;
}
$ && (R = document.createElement("p"));
function Ee(n, t) {
  var r = t;
  if (!R || n === "content") return t;
  if (typeof r != "string" || !isNaN(parseInt(r, 10)))
    return r;
  var e = n + r;
  if (j[e] != null)
    return j[e];
  try {
    R.style[n] = r;
  } catch {
    return j[e] = !1, !1;
  }
  if (Kr[n])
    r = r.replace(Ur, qr);
  else if (R.style[n] === "" && (r = d.css + r, r === "-ms-flex" && (R.style[n] = "-ms-flexbox"), R.style[n] = r, R.style[n] === ""))
    return j[e] = !1, !1;
  return R.style[n] = "", j[e] = r, j[e];
}
function Jr() {
  function n(i) {
    if (i.type === "keyframes") {
      var s = i;
      s.at = mr(s.at);
    }
  }
  function t(i) {
    for (var s in i) {
      var a = i[s];
      if (s === "fallbacks" && Array.isArray(a)) {
        i[s] = a.map(t);
        continue;
      }
      var o = !1, l = le(s);
      l && l !== s && (o = !0);
      var f = !1, c = Ee(l, C(a));
      c && c !== a && (f = !0), (o || f) && (o && delete i[s], i[l || s] = c || a);
    }
    return i;
  }
  function r(i, s) {
    return s.type !== "style" ? i : t(i);
  }
  function e(i, s) {
    return Ee(s, C(i)) || i;
  }
  return {
    onProcessRule: n,
    onProcessStyle: r,
    onChangeValue: e
  };
}
function Lr() {
  var n = function(r, e) {
    return r.length === e.length ? r > e ? 1 : -1 : r.length - e.length;
  };
  return {
    onProcessStyle: function(r, e) {
      if (e.type !== "style") return r;
      for (var i = {}, s = Object.keys(r).sort(n), a = 0; a < s.length; a++)
        i[s[a]] = r[s[a]];
      return i;
    }
  };
}
function Be() {
  return {
    plugins: [
      Ft(),
      Yt(),
      rr(),
      ar(),
      lr(),
      // Disable the vendor prefixer server-side, it does nothing.
      // This way, we can get a performance boost.
      // In the documentation, we are using `autoprefixer` to solve this problem.
      typeof window > "u" ? null : Jr(),
      Lr()
    ]
  };
}
function Ze(n = {}) {
  const {
    baseClasses: t,
    newClasses: r,
    Component: e
  } = n;
  if (!r)
    return t;
  const i = {
    ...t
  };
  return Object.keys(r).forEach((s) => {
    r[s] && (i[s] = `${t[s]} ${r[s]}`);
  }), i;
}
const A = {
  set: (n, t, r, e) => {
    let i = n.get(t);
    i || (i = /* @__PURE__ */ new Map(), n.set(t, i)), i.set(r, e);
  },
  get: (n, t, r) => {
    const e = n.get(t);
    return e ? e.get(r) : void 0;
  },
  delete: (n, t, r) => {
    n.get(t).delete(r);
  }
}, Dr = he(Be()), Fr = it(), Hr = /* @__PURE__ */ new Map(), Br = {
  disableGeneration: !1,
  generateClassName: Fr,
  jss: Dr,
  sheetsCache: null,
  sheetsManager: Hr,
  sheetsRegistry: null
}, fe = /* @__PURE__ */ b.createContext(Br);
let G;
function pn(n) {
  const {
    children: t,
    injectFirst: r = !1,
    disableGeneration: e = !1,
    ...i
  } = n, s = b.useContext(fe), {
    generateClassName: a,
    jss: o,
    serverGenerateClassName: l,
    sheetsCache: f,
    sheetsManager: c,
    sheetsRegistry: h
  } = {
    ...s,
    ...i
  }, y = b.useMemo(() => {
    const p = {
      disableGeneration: e,
      generateClassName: a,
      jss: o,
      serverGenerateClassName: l,
      sheetsCache: f,
      sheetsManager: c,
      sheetsRegistry: h
    };
    if (!p.jss.options.insertionPoint && r && typeof window < "u") {
      if (!G) {
        const v = document.head;
        G = document.createComment("mui-inject-first"), v.insertBefore(G, v.firstChild);
      }
      p.jss = he({
        plugins: Be().plugins,
        insertionPoint: G
      });
    }
    return p;
  }, [r, e, a, o, l, f, c, h]);
  return /* @__PURE__ */ et.jsx(fe.Provider, {
    value: y,
    children: t
  });
}
let _e = -1e9;
function Zr() {
  return _e += 1, _e;
}
function Me(n) {
  return n.length === 0;
}
function Qr(n) {
  const {
    variant: t,
    ...r
  } = n;
  let e = t || "";
  return Object.keys(r).sort().forEach((i) => {
    i === "color" ? e += Me(e) ? n[i] : U(n[i]) : e += `${Me(e) ? i : U(i)}${U(n[i].toString())}`;
  }), e;
}
const Xr = {};
function Yr(n) {
  const t = typeof n == "function";
  return {
    create: (r, e) => {
      let i;
      try {
        i = t ? n(r) : n;
      } catch (l) {
        throw l;
      }
      if (!e || !r.components || !r.components[e] || !r.components[e].styleOverrides && !r.components[e].variants)
        return i;
      const s = r.components[e].styleOverrides || {}, a = r.components[e].variants || [], o = {
        ...i
      };
      return Object.keys(s).forEach((l) => {
        o[l] = me(o[l] || {}, s[l]);
      }), a.forEach((l) => {
        const f = Qr(l.props);
        o[f] = me(o[f] || {}, l.style);
      }), o;
    },
    options: {}
  };
}
function en({
  state: n,
  stylesOptions: t
}, r, e) {
  if (t.disableGeneration)
    return r || {};
  n.cacheClasses || (n.cacheClasses = {
    // Cache for the finalized classes value.
    value: null,
    // Cache for the last used classes prop pointer.
    lastProp: null,
    // Cache for the last used rendered classes pointer.
    lastJSS: {}
  });
  let i = !1;
  return n.classes !== n.cacheClasses.lastJSS && (n.cacheClasses.lastJSS = n.classes, i = !0), r !== n.cacheClasses.lastProp && (n.cacheClasses.lastProp = r, i = !0), i && (n.cacheClasses.value = Ze({
    baseClasses: n.cacheClasses.lastJSS,
    newClasses: r,
    Component: e
  })), n.cacheClasses.value;
}
function tn({
  state: n,
  theme: t,
  stylesOptions: r,
  stylesCreator: e,
  name: i
}, s) {
  if (r.disableGeneration)
    return;
  let a = A.get(r.sheetsManager, e, t);
  a || (a = {
    refs: 0,
    staticSheet: null,
    dynamicStyles: null
  }, A.set(r.sheetsManager, e, t, a));
  const o = {
    ...e.options,
    ...r,
    theme: t,
    flip: typeof r.flip == "boolean" ? r.flip : t.direction === "rtl"
  };
  o.generateId = o.serverGenerateClassName || o.generateClassName;
  const l = r.sheetsRegistry;
  if (a.refs === 0) {
    let f;
    r.sheetsCache && (f = A.get(r.sheetsCache, e, t));
    const c = e.create(t, i);
    f || (f = r.jss.createStyleSheet(c, {
      link: !1,
      ...o
    }), f.attach(), r.sheetsCache && A.set(r.sheetsCache, e, t, f)), l && l.add(f), a.staticSheet = f, a.dynamicStyles = ze(c);
  }
  if (a.dynamicStyles) {
    const f = r.jss.createStyleSheet(a.dynamicStyles, {
      link: !0,
      ...o
    });
    f.update(s), f.attach(), n.dynamicSheet = f, n.classes = Ze({
      baseClasses: a.staticSheet.classes,
      newClasses: f.classes
    }), l && l.add(f);
  } else
    n.classes = a.staticSheet.classes;
  a.refs += 1;
}
function rn({
  state: n
}, t) {
  n.dynamicSheet && n.dynamicSheet.update(t);
}
function nn({
  state: n,
  theme: t,
  stylesOptions: r,
  stylesCreator: e
}) {
  if (r.disableGeneration)
    return;
  const i = A.get(r.sheetsManager, e, t);
  i.refs -= 1;
  const s = r.sheetsRegistry;
  i.refs === 0 && (A.delete(r.sheetsManager, e, t), r.jss.removeStyleSheet(i.staticSheet), s && s.remove(i.staticSheet)), n.dynamicSheet && (r.jss.removeStyleSheet(n.dynamicSheet), s && s.remove(n.dynamicSheet));
}
function sn(n, t) {
  const r = b.useRef([]);
  let e;
  const i = b.useMemo(() => ({}), t);
  r.current !== i && (r.current = i, e = n()), b.useEffect(
    () => () => {
      e && e();
    },
    [i]
    // eslint-disable-line react-hooks/exhaustive-deps
  );
}
function an(n, t = {}) {
  const {
    // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
    name: r,
    // Help with debuggability.
    classNamePrefix: e,
    Component: i,
    defaultTheme: s = Xr,
    ...a
  } = t, o = Yr(n), l = r || e || "makeStyles";
  return o.options = {
    index: Zr(),
    name: r,
    meta: l,
    classNamePrefix: l
  }, (c = {}) => {
    const h = Ye() || s, y = {
      ...b.useContext(fe),
      ...a
    }, p = b.useRef(), v = b.useRef();
    return sn(() => {
      const S = {
        name: r,
        state: {},
        stylesCreator: o,
        stylesOptions: y,
        theme: h
      };
      return tn(S, c), v.current = !1, p.current = S, () => {
        nn(S);
      };
    }, [h, o]), b.useEffect(() => {
      v.current && rn(p.current, c), v.current = !0;
    }), en(p.current, c.classes, i);
  };
}
const gn = Qe, yn = an, mn = st;
export {
  gn as I,
  pn as S,
  an as a,
  it as b,
  mn as c,
  yn as m,
  rt as n
};
//# sourceMappingURL=mui-DV6TgX2g.mjs.map
